import { useEffect } from 'react'
import { useAppSelector } from '../../store/Hooks'
import AuthenticatorInitializer from './AuthenticatorInitializer'
import ErrorBoundary from '../error_boundary/ErrorBoundary'
import { useTheme } from '@mui/material'
import { orange, deepPurple, yellow, blue } from '@mui/material/colors'

const UIInitializer = () => {
    const mode = useAppSelector(s => s.app.mode)
    const theme = useTheme()

    useEffect(() => {
        const html = document.documentElement

        html.style.setProperty('--mode', mode)

        html.classList.remove('dark-mode')
        html.classList.remove('light-mode')
        html.classList.add(mode + '-mode')
    }, [mode])

    useEffect(() => {
        const html = document.documentElement

        html.style.setProperty('--primary-text-color', theme.palette.text.primary)
        html.style.setProperty('--bg-color', theme.palette.background.default)
        html.style.setProperty('--deepPurple-a200', deepPurple['A200'])
        html.style.setProperty('--yellow-500', yellow['500'])
        html.style.setProperty('--orange-700', orange['700'])
        html.style.setProperty('--blue-a400', blue['A400'])
    }, [theme])

    console.log('rendering UI')
    return (
        <ErrorBoundary>
            <AuthenticatorInitializer />
        </ErrorBoundary>
    )
}

export default UIInitializer
